import React from 'react';
import { AppState } from 'models/app-store';
import { useSelector } from 'react-redux';

type Props = {
  children?: JSX.Element;
};

const PendingParametersWrapper: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const settings = useSelector((state: AppState) => state.settings.settings);

  if(!settings) {
    return null;
  }

  return props.children ? props.children : null;
};

PendingParametersWrapper.displayName = 'PendingParametersWrapper';
PendingParametersWrapper.defaultProps = {};

export default PendingParametersWrapper;
